import camelize from 'camelize'
import { useGeckoAuth } from 'features/auth'
import { RolodexContext } from 'features/rolodex/RolodexProvider'
import { useContext } from 'react'
import useSWR from 'swr'
import { RolodexUserMetadata } from 'types'

/**
 * Hook to fetch all user metadata from the rolodex
 * @returns SWR response with user metadata array
 */
export const useUserListing = () => {
  const { apiURL } = useContext(RolodexContext)
  const { authorizedAxios: axios, isAuthenticated } = useGeckoAuth()

  return useSWR<RolodexUserMetadata[], string>(
    ['/api/v2/permissions/user-metadata/all', isAuthenticated],
    async ([url, isAuthenticated]) => {
      if (!isAuthenticated) {
        return Promise.resolve(null)
      }

      const response = await axios.get(`${apiURL}${url}`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })

      return camelize(response.data)
    }
  )
}
